import { render, staticRenderFns } from "./SvgPlusIcon.vue?vue&type=template&id=361164ca"
import script from "./SvgPlusIcon.vue?vue&type=script&lang=js"
export * from "./SvgPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports